// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aU","header":"aV","copy":"aW","formWrapper":"aX","formLabel":"aY","dismissModal":"aZ","buttonRow":"a0","buttonWrapper":"a1","button":"a2"};